var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"imageInput",attrs:{"accept":"image/*","type":"file","multiple":"","hidden":""},on:{"change":_vm.onChangeImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }